import { Button, ButtonFill, ComponentColor, DialogContent, DialogFooter } from '@tcc/fds';
import { getMessage } from '@tcc/i18n';
import { RegionReportSpinner } from '../../RegionReportSpinner/RegionReportSpinner';
import { BaseFieldRegionReportModalParams } from '../types/modals';
import { RegionReportModal } from '../RegionReportModal';

export interface LoadingViewProps extends BaseFieldRegionReportModalParams {
  onCancelClick: () => void;
}

export const LoadingView = ({
  onOpenChange,
  onCancelClick,
  dialogTestId
}: LoadingViewProps) => (
  <RegionReportModal
    dialogTestId={dialogTestId}
    modalViewKey='dmb-region-report-loading'
    onOpenChange={onOpenChange}
  >
    <DialogContent testId='dmb-region-report-loading'>
      <RegionReportSpinner />
    </DialogContent>
    <DialogFooter>
      <Button
        testId='frr-footer-cancel-button'
        onClick={onCancelClick}
        fill={ButtonFill.Outline}
        color={ComponentColor.Primary}>
          {getMessage('cancel')}
      </Button>
    </DialogFooter>
  </RegionReportModal>
);
